<template>

  <div class="body">

<!--    <el-button @click="visible=true">点击</el-button>-->

      <el-dialog
        :visible.sync="visible"
        width="60%"
        append-to-body>
      <el-card class="box-card mb20">
        <el-form ref="form" :model="queryForm" label-width="80px">
          <el-row>
            <el-col :span="6" class="pr20">
              <el-form-item label="计划名称" prop="trainingProgramName">
                <el-input v-model="queryForm.trainingProgramName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="pr20">
              <el-form-item label="培训类型" prop="trainingCategoryName">
                <el-input
                  clearable
                  @focus="showSelectTreeCategoryVisible"
                  ref="trainingCategoryInput"
                  @clear="trainingCategoryNameClear"
                  :disabled="$route.query.type == 'check'"
                  v-model="queryForm.trainingCategoryName" clearable>
                </el-input>
              </el-form-item>
            </el-col>

            <el-button type="primary" @click="getTableList">搜索</el-button>
            <el-button @click="resetForm('form')">重置</el-button>


          </el-row>
        </el-form>
      </el-card>


            <selectTrainingCategory ref="selectTrainingCategory"
                                    @submit="selectTrainingCategorySubmitHandle"></selectTrainingCategory>
      <!--table-->
      <el-card class="box-card" style="padding-bottom:20px;">
        <el-table class="mb20" :data="tableList" style="width: 100%" v-loading="tableLoading"
                  element-loading-text="拼命加载中"
        >
          <el-table-column fixed="left" type="index" label="单选" align="center" width="80">
            <template slot-scope="scope">
              <el-radio v-model="currentRowId" :label="scope.row.id" @change="changeRedio($event,scope.row)">&nbsp;</el-radio>
            </template>
          </el-table-column>

          <el-table-column fixed="left" type="index" width="60" label="序号"
                           :show-overflow-tooltip="true"></el-table-column>
          <el-table-column fixed="left" prop="trainingProgramName" width="150" label="计划名称"
                           :show-overflow-tooltip="true">
          </el-table-column>

          <el-table-column width="200" label="培训类型"
                           :show-overflow-tooltip="true">
            <template slot-scope="scope">
            <span v-if="scope.row.trainingTypeName" v-html="scope.row.trainingTypeName">
            </span>
              <span v-else>
               --
            </span>
            </template>
          </el-table-column>

          <el-table-column prop="method" label="培训方式" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-if="scope.row.method == 1">线上培训</span>
              <span v-if="scope.row.method == 2">线下培训</span>
            </template>
          </el-table-column>
          <el-table-column prop="assessmentMethod" label="考核方式" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-if="scope.row.assessmentMethod == 1">笔试</span>
              <span v-if="scope.row.assessmentMethod == 2">实操</span>
              <span v-if="scope.row.assessmentMethod == 3">笔试+实操</span>
            </template>
          </el-table-column>
          <el-table-column prop="teacher" label="培训讲师" :show-overflow-tooltip="true"></el-table-column>


        </el-table>

        <el-button style="margin-bottom: 8px" type="primary" size="small" @click="ok">确 定</el-button>

        <el-pagination
          style="float:right;"
          background
          layout="total ,prev, pager, next"
          :total="total"
          :page-size="pageSize"
          @current-change="pageChange"
        ></el-pagination>
      </el-card>

    </el-dialog>







  </div>
</template>
<script>

import api from "@/api/new/safety_raining_program.js";
import entFile from "@/api/new/ent_file.js";
import util from "@/common/util.js";
import selectTrainingCategory from "@/components/training/selectTrainingCategory";

export default {
  name:"tariningPrograms",
  components: {selectTrainingCategory},
  data() {
    return {
      visible:false,
      Training:{
        address:undefined,
        assessmentMethod:undefined,
        classHours:undefined,
        endTime:undefined,
        evaluation:undefined,
        funding:undefined,
        id:undefined,
        method:undefined,
        startTime:undefined,
        teacher:undefined,
        teacherId:undefined,
        trainingCategoryName:undefined,
        trainingIndustryId:undefined,
        trainingIndustryName:undefined,
        trainingLevelId:undefined,
        trainingLevelName:undefined,
        trainingObject:undefined,
        trainingPostId:undefined,
        trainingPostName:undefined,
        trainingProgramId:undefined,
        trainingProgramName:undefined,
        trainingTypeId:undefined,
        trainingTypeName:undefined,
        safetyTrainingProgramId:undefined,
        safetyTrainingProgramName:undefined,

      },
      currentRowId:'',
      //  query form
      queryForm: {
        trainingProgramName: undefined,

        // training
        trainingLevelName: undefined,
        trainingIndustryName: undefined,
        trainingPostName: undefined,
        trainingTypeName: undefined,

        trainingCategoryName: undefined
      },
      // current file type
      currentFileType: 1,


      // table obj
      tableList: [],
      page: 1,
      pageSize: 10,
      total: 0, // 总条数

      // dialog and  form
      exportDialogVisible: false,
      exportDialogTitle: '培训记划导出',
      exportForm: {
        date: undefined
      },
      exportFormRules: {
        date: [{required: true, message: "请选择导出年度", trigger: "blur"}],
      },
      currentExportType: 1,
      tableLoading: false

    };
  },
  mounted() {


    // quer page table
    this.getTableList();
  },
  methods: {
    show(){
      this.visible=true;
    },
    edit(id,vales){
      console.log(id)
      this.visible=true;
      this.Training.id=id;
      this.Training.trainingProgramName=vales;
      this.currentRowId=id;
    },
    ok(){
      console.log("log---------------------"+this.Training)
      this.visible=false;
      this.$emit("submit", this.Training);
    console.log(this.currentRowId)

      if(this.Training ===null || this.Training ===''){
        this.$message.error("请选择计划")
        this.visible=true;
      }

    },
    changeRedio(event,row){
      this.Training=row;
      console.log('event,row:',event,row);
      this.currentRowId = event;
    },
    getTableList() {
      let parmas = {
        ...this.queryForm,
        page: this.page,
        pageSize: this.pageSize,
        type: this.type,
        enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId,
      };
      delete parmas.trainingCategoryName;


      console.log('getTableList, parmas = ', parmas)
      this.tableLoading = true;
      api.queryOfflineList(parmas).then(res => {
        this.tableList = res.data.records;
        this.total = res.data.total;
        this.tableLoading = false;
      });
    },
    resetForm(formName) {
      this.trainingCategoryNameClear();
      this.$refs[formName].resetFields();
    },
    pageChange(e) {
      this.page = e;
      this.getTableList();
    },
    del(id) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        api.del({id: id}).then(res => {
          if (res.code == 0) {
            this.$message.success("成功");
            this.getTableList();
          } else {
            this.$message.error("失败");
          }
        });
      });
    },
    // export
    exportFile() {
      let params = {
        date: this.exportForm.date.getTime()
      }
      if (this.currentExportType == 1) { // 年度计划
        entFile.exportAnnualSafetyTrainingPlan(params).then(res => {
          if (res.error) {
            this.$message.error(res.error);
          }
          util.downloadBlobFile(res, this.exportForm.date.getFullYear() + '安全教育培训年度.docx');
          this.$message.success("导出成功");
          this.closeExportDialog();
        }, (err) => {
          this.$message.error("选中年度没有计划数据!");
        });
      } else { // 年度台账
        entFile.exportAnnualTrainingLedger(params).then(res => {
          if (res.error) {
            this.$message.error(res.error);
          }
          util.downloadBlobFile(res, this.exportForm.date.getFullYear() + '年度培训台账.docx');
          this.$message.success("导出成功");
          this.closeExportDialog();
        }, (err) => {
          this.$message.error("选中年度没有培训数据!");
        });
      }
    },
    exportFormClear() {
      this.exportForm = {
        date: undefined
      }
    },
    showExportDialog(type) {
      this.currentExportType = type;
      if (this.currentExportType == 1) {
        this.exportDialogTitle = '安全培训记划导出';
      } else {
        this.exportDialogTitle = '安全培训年度台账导出';
      }
      this.exportDialogVisible = true;
    },
    closeExportDialog() {
      this.exportDialogVisible = false;
      this.exportFormClear();
      this.$refs["exportForm"].resetFields();
    },

    trainingCategoryNameClear() {
      this.queryForm.trainingLevelName = undefined;
      this.queryForm.trainingIndustryName = undefined;
      this.queryForm.trainingPostName = undefined;
      this.queryForm.trainingTypeName = undefined;
    },
    showSelectTreeCategoryVisible() {
      this.$refs.trainingCategoryInput.blur();
      this.$refs.selectTrainingCategory.showDialog();
    },
    selectTrainingCategorySubmitHandle(data) {
      this.queryForm.trainingLevelName = data.trainingLevelName;
      this.queryForm.trainingIndustryName = data.trainingIndustryName;
      this.queryForm.trainingPostName = data.trainingPostName;
      this.queryForm.trainingTypeName = data.trainingTypeName;
      this.queryForm.trainingCategoryName = data.trainingCategoryName;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/pages/trainingManagement/safetyTrainingProgram/trainingProgram/list.vue